<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="transactions"
      :items-per-page="20"
      class="elevation-1"
  ></v-data-table>
  </v-container>
</template>

<script>

export default {
  mounted() {
    this.$store.dispatch('userTransactions');
  },
  computed: {
    transactions() {
      console.log(this.$store.state.transactions);
      return this.$store.getters['getTransactions'] || [];
    },
  },
  data: () => ({
    headers: [
      {
        text: 'DateTime',
        align: 'start',
        sortable: false,
        value: 'timestamp',
      },
      { text: 'Type', value: 'type' },
      { text: 'Ref', value: 'reference' },
      { text: 'Ext Ref', value: 'extReference' },
      { text: 'Description', value: 'descrition' },
      { text: 'Amount', value: 'amount' },
    ],
  }),
}
</script>
